<template>
    <div class="o-mobile-guide mobile-guide">
        <component
            :is="defineComponent"
            @onStart="handleComponents('proceed')"
            @onClose="handleComponents('start')"
            @resetGuideShow="event => isResetGuideShow = event"
        />
        <div
            :class="[
                'o-mobile-guide__back-button-wrapper',
                {'start': currentUnit === 'start'},
                {'proceedWithResetButton': currentUnit === 'proceed' && isResetGuideShow}
            ]"
        >
            <AMBackButton
                theme="back"
                :text="$t('ui.back')"
                @onClick="handleClickBack"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import OMobileGuideStart from '../../unique-organisms/o-mobile-guide-start/o-mobile-guide-start';
import OMobileGuideSteps from '../../unique-organisms/o-mobile-guide-steps/o-mobile-guide-steps';

import { PATH_REBUILDED } from '../../../utils/constants/bus-events-constants';
import {
    MOBILE_ROOT,
    MOBILE_GUIDE,
    MOBILE_SERVICES
} from '../../../utils/constants/pages';
import { UI_STEP_SELECTED } from "../../../shared/components/map-viewer/constants/map-events";

export default {
    name: 'OMobileGuide',
    components: {
        OMobileGuideStart,
        OMobileGuideSteps,
        AMBackButton
    },
    data() {
        return {
            currentUnit: 'start',
            units: {
                start: 'OMobileGuideStart',
                proceed: 'OMobileGuideSteps'
            },
            isResetGuideShow: false
        }
    },
    computed: {
        ...mapState({
            isMobileGuideStartActivate: state => state.isMobileGuideStartActivate
        }),
        defineComponent() {
            return this.units[this.currentUnit];
        }
    },
    watch: {
        isMobileGuideStartActivate(value) {
            if (value) this.handleComponents('proceed');
        }
    },
    mounted() {
        this.initEventsListeners();
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    methods: {
        initEventsListeners() {
            this.$bus.$on(PATH_REBUILDED, this.restoreView);
            this.$bus.$on(UI_STEP_SELECTED, this.runNavigation);
        },
        deactivateEventsListeners() {
            this.$bus.$off(PATH_REBUILDED, this.restoreView);
            this.$bus.$off(UI_STEP_SELECTED, this.runNavigation);
        },
        handleComponents(data) {
            this.currentUnit = data;
        },
        restoreView() {
            this.handleComponents('start');
        },
        runNavigation() {
            this.handleComponents('proceed');
        },
        handleClickBack() {
            const params = this.$route.params.type
                ? { name: `mobile.${this.$route.params.type}`}
                : { name: MOBILE_ROOT };
            if (this.$route.params.type === 'service') params.name = MOBILE_SERVICES;
            //TODO: need to adjust consistency name route between themes
            if (this.$route.params.type === 'start') params.name = MOBILE_ROOT;
            this.$router.push(params);
        },
    }
}
</script>

<style lang="scss">
@import "o-mobile-guide";
</style>